import { Entity, EntityFields } from '@prodcard/core'
import { omit, toArray } from 'lodash'

export function removeFieldsFromEntity<T extends Entity>(entity?: T): Omit<T, EntityFields> | undefined {
  return entity ? omit(entity, toArray(EntityFields)) : undefined
}
